/* RD Tabbed Content 2.1.0 — navigation is built from rendered tab containers. */
(function () {
  'use strict';
  if (window.RDTabbedContent) {
    window.RDTabbedContent.initAll(document);
    return;
  }

  var selector = '[data-rd-tabbed-content]';
  var controllers = new Map();
  var editorSelections = new Map();

  function decodedHash() {
    var value = window.location.hash.slice(1);
    try { return decodeURIComponent(value); } catch (error) { return value; }
  }

  function create(root) {
    function ownPanels() {
      return Array.from(root.querySelectorAll('[data-rdtc-panel]')).filter(function (panel) { return panel.closest(selector) === root; });
    }
    var panels = ownPanels();
    var navbar = root.querySelector('[data-rdtc-navbar]');
    var viewport = root.querySelector('[data-rdtc-viewport]');
    var track = root.querySelector('[data-rdtc-tablist]');
    var select = root.querySelector('[data-rdtc-select]');
    var previous = root.querySelector('[data-rdtc-prev]');
    var next = root.querySelector('[data-rdtc-next]');
    var hint = root.querySelector('[data-rdtc-hint]');
    var status = root.querySelector('[data-rdtc-status]');
    var navbarWasHidden = navbar ? navbar.hidden : true;
    // Theme block drops need not expose their file type/settings to siblings.
    // Every Tab container publishes its own label on its rendered root instead.
    if (track) track.replaceChildren();
    if (select) select.replaceChildren();
    panels.forEach(function (panel, index) {
      var label = panel.dataset.rdtcLabel || panel.getAttribute('aria-label') || 'Tab ' + (index + 1);
      panel.dataset.rdtcLabel = label;
      if (!track) return;
      var link = document.createElement('a');
      link.className = 'rdtc-tab';
      link.id = root.id + '-tab-' + panel.dataset.rdtcPanel;
      link.href = '#' + encodeURIComponent(panel.id);
      link.dataset.rdtcTab = panel.dataset.rdtcPanel;
      link.dataset.tabLabel = label;
      if (navbar && navbar.dataset.rdtcShowNumbers === 'true') {
        var number = document.createElement('span');
        number.className = 'rdtc-tab-number';
        number.setAttribute('aria-hidden', 'true');
        number.textContent = String(index + 1);
        link.appendChild(number);
      }
      var text = document.createElement('span');
      text.textContent = label;
      link.appendChild(text);
      track.appendChild(link);
      if (select) {
        var option = document.createElement('option');
        option.value = panel.dataset.rdtcPanel;
        option.textContent = label;
        select.appendChild(option);
      }
    });
    var links = track ? Array.from(track.querySelectorAll('[data-rdtc-tab]')) : [];
    if (navbar) navbar.hidden = root.dataset.navigation === 'false' || !links.length;
    var editor = root.dataset.editor === 'true' || Boolean(window.Shopify && window.Shopify.designMode);
    var navigation = Boolean(navbar && !navbar.hidden && root.dataset.navigation !== 'false' && links.length);
    var tabMode = navigation && root.dataset.displayMode !== 'anchor';
    var media = window.matchMedia('(max-width: 767px)');
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var removers = [];
    var active = null;
    var frame = 0;
    var initialFrame = 0;
    var destroyed = false;
    var resizeObserver = null;
    var intersectionObserver = null;
    var initial = (root.dataset.initialTab || '').trim();
    var storageKey = 'rd-tabbed-content:' + window.location.pathname + ':' + root.dataset.sectionId;

    function configurationKey() {
      return JSON.stringify([
        root.dataset.displayMode, root.dataset.navigation, root.dataset.initialTab,
        root.dataset.updateHash, root.dataset.editor,
        navbar && navbar.dataset.layoutDesktop, navbar && navbar.dataset.layoutMobile,
        navbar && navbar.dataset.arrowsDesktop, navbar && navbar.dataset.arrowsMobile,
        navbar && navbar.dataset.showHint, navbar && navbar.dataset.rdtcShowNumbers,
        panels.map(function (panel) { return [panel.dataset.rdtcLabel, panel.dataset.rdtcAlias]; })
      ]);
    }
    var configured = configurationKey();

    function listen(target, name, handler, options) {
      if (!target) return;
      target.addEventListener(name, handler, options);
      removers.push(function () { target.removeEventListener(name, handler, options); });
    }

    function linkFor(panel) {
      return links.find(function (link) { return link.dataset.rdtcTab === panel.dataset.rdtcPanel; });
    }

    function resolve(value) {
      if (!value) return null;
      var clean = value.replace(/^#/, '');
      var lower = clean.toLowerCase();
      return panels.find(function (panel) { return panel.id === clean || panel.dataset.rdtcPanel === clean; }) ||
        panels.find(function (panel) {
          var link = linkFor(panel);
          return (panel.dataset.rdtcAlias || '').toLowerCase() === lower ||
            Boolean(link && (link.dataset.tabLabel || '').toLowerCase() === lower);
        }) || null;
    }

    function hashPanel() {
      var value = decodedHash();
      if (!value) return null;
      var exact = panels.find(function (panel) { return panel.id === value; });
      if (exact) return exact;
      // Legacy footer keys belong to the first matching section on the page.
      var first = Array.from(document.querySelectorAll('[data-rdtc-panel]')).find(function (panel) {
        return (panel.dataset.rdtcAlias || '').toLowerCase() === value.toLowerCase();
      });
      return first && panels.indexOf(first) !== -1 ? first : null;
    }

    function saveSelection(panel) {
      if (!editor) return;
      var state = { id: panel.dataset.rdtcPanel, initial: initial };
      editorSelections.set(storageKey, state);
      try { window.sessionStorage.setItem(storageKey, JSON.stringify(state)); } catch (error) { /* Storage may be unavailable in the editor iframe. */ }
    }

    function restoredPanel() {
      if (!editor) return null;
      var state = editorSelections.get(storageKey);
      if (!state) {
        try { state = JSON.parse(window.sessionStorage.getItem(storageKey)); } catch (error) { state = null; }
      }
      return state && state.initial === initial ? panels.find(function (panel) { return panel.dataset.rdtcPanel === state.id; }) : null;
    }

    function layout() {
      return navbar ? (media.matches ? navbar.dataset.layoutMobile : navbar.dataset.layoutDesktop) || 'scroll' : 'wrap';
    }

    function behavior() { return reducedMotion.matches ? 'auto' : 'smooth'; }
    function isRTL() { return viewport && window.getComputedStyle(viewport).direction === 'rtl'; }

    function updateScrollControls() {
      frame = 0;
      if (destroyed || !viewport) return;
      var maximum = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
      var overflow = navigation && layout() === 'scroll' && maximum > 2;
      var showArrows = navbar && (media.matches ? navbar.dataset.arrowsMobile : navbar.dataset.arrowsDesktop) !== 'false';
      var distance = Math.max(0, Math.min(maximum, isRTL() ? -viewport.scrollLeft : viewport.scrollLeft));
      if (previous) { previous.hidden = !overflow || !showArrows; previous.disabled = distance <= 2; }
      if (next) { next.hidden = !overflow || !showArrows; next.disabled = distance >= maximum - 2; }
      if (hint) hint.hidden = !overflow || !media.matches || navbar.dataset.showHint === 'false';
    }

    function scheduleControls() {
      if (!destroyed && !frame) frame = window.requestAnimationFrame(updateScrollControls);
    }

    function revealLink(panel, instant) {
      var link = linkFor(panel);
      if (!link || !viewport || !navigation || layout() !== 'scroll') return;
      var bounds = viewport.getBoundingClientRect();
      var rect = link.getBoundingClientRect();
      var delta = rect.left < bounds.left + 4 ? rect.left - bounds.left - 4 :
        rect.right > bounds.right - 4 ? rect.right - bounds.right + 4 : 0;
      if (delta) viewport.scrollTo({ left: viewport.scrollLeft + delta, behavior: instant ? 'auto' : behavior() });
      scheduleControls();
    }

    function scrollPanel(panel, instant) {
      var offset = parseFloat(window.getComputedStyle(root).getPropertyValue('--rdtc-scroll-offset'));
      if (!Number.isFinite(offset)) offset = 0;
      window.scrollTo({ top: Math.max(0, panel.getBoundingClientRect().top + window.scrollY - offset), behavior: instant ? 'auto' : behavior() });
    }

    function choose(panel, options) {
      if (!panel || destroyed) return;
      options = options || {};
      var oldPanel = active;
      var recoverFocus = tabMode && oldPanel && oldPanel !== panel && oldPanel.contains(document.activeElement);
      active = panel;
      panels.forEach(function (candidate) {
        var selected = candidate === panel;
        candidate.hidden = tabMode && !selected;
        candidate.classList.toggle('is-active', selected);
      });
      links.forEach(function (link) {
        var selected = link.dataset.rdtcTab === panel.dataset.rdtcPanel;
        link.classList.toggle('is-active', selected);
        if (tabMode) {
          link.setAttribute('aria-selected', String(selected));
          link.tabIndex = selected ? 0 : -1;
        } else if (selected && navigation) link.setAttribute('aria-current', 'location');
        else link.removeAttribute('aria-current');
      });
      if (select) select.value = panel.dataset.rdtcPanel;
      if (options.reveal !== false) revealLink(panel, options.instant);
      var link = linkFor(panel);
      if (options.focus || recoverFocus) (link && layout() !== 'dropdown' ? link : panel).focus({ preventScroll: true });
      if (options.announce && status) status.textContent = (link ? link.dataset.tabLabel : panel.getAttribute('aria-label')) || 'Information';
      if (options.hash && !editor && root.dataset.updateHash !== 'false') {
        var hash = '#' + encodeURIComponent(panel.id);
        if (window.location.hash !== hash) window.history.replaceState(window.history.state, '', window.location.pathname + window.location.search + hash);
      }
      if (options.scroll && !tabMode) scrollPanel(panel, options.instant);
      saveSelection(panel);
      scheduleControls();
    }

    if (track && tabMode) track.setAttribute('role', 'tablist');
    panels.forEach(function (panel) {
      var link = linkFor(panel);
      if (tabMode && link) {
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', link.id);
        panel.removeAttribute('aria-label');
        link.setAttribute('role', 'tab');
        link.setAttribute('aria-controls', panel.id);
      }
    });
    var selected = restoredPanel() || hashPanel() || resolve(initial) || panels[0];
    choose(selected, { instant: true, reveal: false });
    root.dataset.rdtcReady = 'true';

    listen(root, 'click', function (event) {
      var link = event.target.closest('[data-rdtc-tab]');
      if (!link || !root.contains(link) || event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      choose(resolve(link.dataset.rdtcTab), { hash: true, scroll: true, announce: tabMode });
    });
    listen(track, 'keydown', function (event) {
      if (!tabMode || event.altKey || event.metaKey || event.ctrlKey) return;
      var link = event.target.closest('[data-rdtc-tab]');
      var index = links.indexOf(link);
      if (index < 0) return;
      var target;
      var direction = isRTL() ? -1 : 1;
      if (event.key === 'ArrowRight') target = (index + direction + links.length) % links.length;
      else if (event.key === 'ArrowLeft') target = (index - direction + links.length) % links.length;
      else if (event.key === 'Home') target = 0;
      else if (event.key === 'End') target = links.length - 1;
      if (target === undefined) return;
      event.preventDefault();
      choose(resolve(links[target].dataset.rdtcTab), { focus: true, hash: true, announce: true });
    });
    listen(select, 'change', function () { choose(resolve(select.value), { hash: true, scroll: true, announce: tabMode }); });
    function pageNavigation(direction) {
      if (!viewport) return;
      viewport.scrollBy({ left: direction * (isRTL() ? -1 : 1) * Math.max(80, viewport.clientWidth * 0.8), behavior: behavior() });
      scheduleControls();
    }
    listen(previous, 'click', function () { pageNavigation(-1); });
    listen(next, 'click', function () { pageNavigation(1); });
    listen(viewport, 'scroll', scheduleControls, { passive: true });
    listen(window, 'resize', scheduleControls, { passive: true });
    listen(window, 'hashchange', function () {
      var panel = hashPanel();
      if (panel) choose(panel, { scroll: !editor, announce: tabMode });
    });
    function mediaChanged() {
      if (active) revealLink(active, true);
      scheduleControls();
    }
    if (media.addEventListener) listen(media, 'change', mediaChanged);
    else if (media.addListener) { media.addListener(mediaChanged); removers.push(function () { media.removeListener(mediaChanged); }); }
    if (document.fonts && document.fonts.addEventListener) listen(document.fonts, 'loadingdone', scheduleControls);

    listen(root, 'shopify:block:select', function (event) {
      // The event target disambiguates identical nested IDs in different tabs.
      var panel = event.target.closest('[data-rdtc-panel]');
      if (!panel && event.detail && event.detail.blockId) panel = panels.find(function (candidate) { return candidate.dataset.rdtcPanel === event.detail.blockId; });
      if (panel && panels.indexOf(panel) !== -1) choose(panel, { instant: true, scroll: !tabMode, announce: false });
    });

    if (window.ResizeObserver && viewport) {
      resizeObserver = new window.ResizeObserver(scheduleControls);
      resizeObserver.observe(viewport);
      if (track) resizeObserver.observe(track);
    }
    if (window.IntersectionObserver && navigation && !tabMode && !editor) {
      var visiblePanels = new Map();
      intersectionObserver = new window.IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) visiblePanels.set(entry.target, entry.boundingClientRect.top);
          else visiblePanels.delete(entry.target);
        });
        var closest = Array.from(visiblePanels.keys()).sort(function (a, b) {
          return Math.abs(a.getBoundingClientRect().top) - Math.abs(b.getBoundingClientRect().top);
        })[0];
        if (closest && closest !== active) choose(closest, { reveal: false });
      }, { rootMargin: '-15% 0px -55% 0px', threshold: 0 });
      panels.forEach(function (panel) { intersectionObserver.observe(panel); });
    }
    initialFrame = window.requestAnimationFrame(function () {
      initialFrame = 0;
      if (destroyed) return;
      if (selected) revealLink(selected, true);
      updateScrollControls();
      if (!editor && hashPanel() && selected) scrollPanel(selected, true);
    });

    return {
      isCurrent: function () {
        var current = ownPanels();
        return !destroyed && root.querySelector('[data-rdtc-navbar]') === navbar &&
          root.querySelector('[data-rdtc-tablist]') === track &&
          current.length === panels.length && current.every(function (panel, index) { return panel === panels[index]; }) &&
          (!track || links.length === track.querySelectorAll('[data-rdtc-tab]').length && links.every(function (link) { return track.contains(link); })) &&
          configured === configurationKey();
      },
      destroy: function () {
        destroyed = true;
        removers.forEach(function (remove) { remove(); });
        if (resizeObserver) resizeObserver.disconnect();
        if (intersectionObserver) intersectionObserver.disconnect();
        if (frame) window.cancelAnimationFrame(frame);
        if (initialFrame) window.cancelAnimationFrame(initialFrame);
        panels.forEach(function (panel) {
          panel.hidden = false;
          panel.classList.remove('is-active');
          panel.removeAttribute('role');
          panel.removeAttribute('aria-labelledby');
          var link = linkFor(panel);
          if (link) panel.setAttribute('aria-label', link.dataset.tabLabel || 'Information');
        });
        links.forEach(function (link) {
          link.classList.remove('is-active');
          ['role', 'aria-controls', 'aria-selected', 'aria-current', 'tabindex'].forEach(function (attribute) { link.removeAttribute(attribute); });
        });
        if (track) track.removeAttribute('role');
        if (previous) previous.hidden = true;
        if (next) next.hidden = true;
        if (hint) hint.hidden = true;
        if (track) track.replaceChildren();
        if (select) select.replaceChildren();
        if (navbar) navbar.hidden = navbarWasHidden;
        delete root.dataset.rdtcReady;
      }
    };
  }

  function initAll(scope) {
    Array.from(controllers.keys()).forEach(function (root) {
      if (!root.isConnected) { controllers.get(root).destroy(); controllers.delete(root); }
    });
    var roots = scope.matches && scope.matches(selector) ? [scope] : [];
    roots = roots.concat(Array.from(scope.querySelectorAll(selector)));
    roots.forEach(function (root) {
      var controller = controllers.get(root);
      if (controller && !controller.isCurrent()) { controller.destroy(); controllers.delete(root); }
      if (!controllers.has(root)) controllers.set(root, create(root));
    });
  }
  function destroyAll(scope) {
    Array.from(controllers.keys()).forEach(function (root) {
      if (scope === root || scope.contains(root)) { controllers.get(root).destroy(); controllers.delete(root); }
    });
  }
  window.RDTabbedContent = { version: '2.1.0', initAll: initAll, destroyAll: destroyAll };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); }, { once: true });
  else initAll(document);
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
  document.addEventListener('shopify:section:unload', function (event) { destroyAll(event.target); });
})();
